import Api from 'api';

import {
  GET_CATALOGS,
  SET_CATALOGS_PAGINATION,
  SET_CATALOGS_FILTERS,
  RESET_CATALOGS,
  TOGGLE_CATALOG,
  ADD_CATALOG,
  UPDATE_CATALOG,
  GET_CATALOG_BY_ID,
  RESET_CATALOG_FORM,
  MODIFY_EDITING_CATALOG,
  ADD_ELEMENT_EDITING_CATALOG,
  REMOVE_ELEMENT_EDITING_CATALOG,
} from 'catalogs/constants';

export const setPagination = (payload) => ({
  type: SET_CATALOGS_PAGINATION,
  payload,
});

export const setFilters = (payload) => ({
  type: SET_CATALOGS_FILTERS,
  payload,
});

export const getCatalogs = (companyId, subcompanyId, filters, limit, page, orderBy, order) => ({
  type: GET_CATALOGS,
  meta: { needAuth: true },
  payload: Api.catalogs.get(companyId, subcompanyId, filters, limit, page, orderBy, order),
});

export const reset = () => ({ type: RESET_CATALOGS });

export const toggle = (catalogId, companyId, subcompanyId) => ({
  type: TOGGLE_CATALOG,
  meta: { id: catalogId, needAuth: true },
  payload: Api.catalogs.toggle(catalogId, companyId, subcompanyId),
});

export const resetForm = () => ({ type: RESET_CATALOG_FORM });

export const getCatalogById = (catalogId, companyId, subcompanyId) => ({
  type: GET_CATALOG_BY_ID,
  meta: { needAuth: true },
  payload: Api.catalogs.getById(catalogId, companyId, subcompanyId),
});

export const modifyCatalog = (payload) => ({ type: MODIFY_EDITING_CATALOG, payload });

export const addCatalog = (companyId, subcompanyId, catalog) => ({
  type: ADD_CATALOG,
  payload: Api.catalogs.add(companyId, subcompanyId, catalog),
});

export const updateCatalog = (catalogId, companyId, subcompanyId, catalog) => ({
  type: UPDATE_CATALOG,
  meta: { id: catalogId, needAuth: true },
  payload: Api.catalogs.update(catalogId, companyId, subcompanyId, catalog),
});

export const addElement = () => ({ type: ADD_ELEMENT_EDITING_CATALOG });

export const removeElement = (index) => ({
  type: REMOVE_ELEMENT_EDITING_CATALOG,
  payload: index,
});



// WEBPACK FOOTER //
// src/modules/secured/modules/catalogs/actions/catalogs_actions.js